export default __webpack_public_path__ + "static/media/thumb-banner4.11cb66d9.jpg";